import {
    STATUS_AVAILABLE,
    STATUS_LOCKED,
} from '../../constants/status-constants';

export const getSeatStatus = (statusRecord) => {
    let seatStatus;

    if (statusRecord) {
        if (statusRecord.S) {
            seatStatus =
                statusRecord.S.A || statusRecord.S.P
                    ? STATUS_AVAILABLE
                    : STATUS_LOCKED;
        } else {
            seatStatus = statusRecord.s;
        }
    }

    return seatStatus;
};
